export const extractDigits = (first_name) => {
    const name = first_name?.split("[")[1];
    const digits = name.split("]")[0];
    return digits;
  };

  // eslint-disable-next-line import/no-anonymous-default-export
  export default {extractDigits}